<div style="max-height: 90vh !important" class="card card-custom d-flex flex-column">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ 'TASK.SHARE_ATTACHMENT.TITLE' | translate }}</h3>
    </div>
  </div>
  <div
    style="max-height: unset !important"
    class="card-body flex-grow-1 scroll"
    [perfectScrollbar]="{ wheelPropagation: false }"
  >
    <form [formGroup]="form" class="form form-group mb-0">
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'TASK.SHARE_ATTACHMENT.SUBJECT' | translate }}</mat-label>
        <input matInput type="text" formControlName="subject" required />
        <mat-error *ngIf="isInvalid('subject')">{{
          getErrorMessage('TASK.SHARE_ATTACHMENT.SUBJECT' | translate)
        }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'TASK.SHARE_ATTACHMENT.ATTACHMENTS' | translate }}</mat-label>
        <mat-select formControlName="attachments" multiple required>
          <mat-option *ngFor="let a of data.attachments" [value]="a">{{
            a.path?.substring(a.path?.lastIndexOf('/') + 1)
          }}</mat-option>
        </mat-select>
        <mat-error *ngIf="isInvalid('attachments')">{{
          getErrorMessage('TASK.SHARE_ATTACHMENT.ATTACHMENTS' | translate)
        }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100 mb-4">
        <mat-label>{{ 'TASK.SHARE_ATTACHMENT.METHODS' | translate }}</mat-label>
        <mat-select
          formControlName="methods"
          multiple
          required
          (selectionChange)="handleMethodsChange()"
        >
          <mat-option *ngFor="let m of sharingMethods" [value]="m">{{
            m | enumFormat : '_'
          }}</mat-option>
        </mat-select>
        <mat-error *ngIf="isInvalid('methods')">{{
          getErrorMessage('TASK.SHARE_ATTACHMENT.METHODS' | translate)
        }}</mat-error>
      </mat-form-field>
      <div class="w-100 mb-4">
        <kt-general-autocomplete
          #receiverAutocomplete
          [label]="'TASK.SHARE_ATTACHMENT.TO' | translate"
          [appearance]="'fill'"
          [chipList]="true"
          [dataPath]="'data'"
          [objects]="receiverAutocomplete.value"
          [loadItemsFunction]="getReceiverAutocomplete"
          [optionFormatter]="formatReceiverOption"
          [valueFormatter]="formatReceiverOption"
          [formatNewObjectFn]="formatNewReceiver"
          [readOnly]="!form.get('attachments').value?.length"
          [required]="true"
        ></kt-general-autocomplete>
      </div>
      <quill-editor formControlName="body" [modules]="quillModules"></quill-editor>
    </form>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="close($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="send($event)"
    >
      {{ 'GLOBAL.SEND' | translate }}
    </button>
  </div>
</div>
